import { WarningCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import type { MatchingResponse } from "./types";

interface Props {
  crisis: NonNullable<MatchingResponse["crisis"]>;
  onRestart: () => void;
}

export function CrisisResult({ crisis, onRestart }: Props) {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-2xl flex-col justify-center gap-5 px-4 py-10">
      <div className="rounded-xl border bg-card p-6 shadow-sm">
        <div className="flex items-start gap-4">
          <div className="grid size-11 shrink-0 place-items-center rounded-lg bg-destructive/10 text-destructive">
            <WarningCircle className="size-6" />
          </div>
          <div className="min-w-0">
            <h1 className="text-2xl font-semibold text-foreground" style={{ fontFamily: "var(--font-heading)" }}>
              {crisis.title}
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{crisis.body}</p>
            <p className="mt-4 rounded-lg bg-muted/50 px-3 py-2 text-sm font-medium text-foreground">
              Hitni broj: {crisis.emergencyNumber}
            </p>
          </div>
        </div>
        <div className="mt-6 flex flex-wrap gap-2">
          <Button asChild>
            <a href={crisis.therapistListUrl}>Pregledaj terapeute za neurgentnu podršku</a>
          </Button>
          <Button type="button" variant="outline" onClick={onRestart}>
            Promijeni odgovore
          </Button>
        </div>
      </div>
    </div>
  );
}
